import React from 'react';
import { Box, Flex, Image } from '@qga/roo-ui/components';

import { brandColors } from '@/lib/theme/colors';
import getAsset from '@/utils/getAsset';
import Text from '../../components/Text';
import Heading from '../Heading';
import qantas_points_element from './assets/qantas_points_element.svg';

const QantasPointBanner = ({
  title,
  description,
  maxWidth = '100%',
  backgroundColor = 'background.banner',
  my = 4,
}: {
  title?: string;
  description?: React.ReactNode;
  backgroundColor?: string;
  maxWidth?: string;
  my?: number;
}) => {
  const imageSize = title ? 48 : 36;

  const descriptionContent = description || (
    <>
      You’ll earn{' '}
      <Text fontSize="sm" fontWeight="700">
        10,000 Qantas Points
      </Text>{' '}
      on this booking*
    </>
  );

  return (
    <Box
      maxWidth={maxWidth}
      bg={backgroundColor}
      borderRadius={8}
      py={4}
      px={title ? 6 : 2}
      my={my}
    >
      <Flex alignItems="center" gap={title ? [2, null, 4] : 2} width="100%">
        <Image
          src={getAsset(qantas_points_element)}
          alt="Qantas Logo Diamond Decal"
          width={imageSize}
          height={imageSize}
        />
        <Flex flexDirection="column">
          {title && <Heading.h5 textAlign="left">{title}</Heading.h5>}
          <Text
            display={title ? ['none', null, 'block'] : 'block'}
            fontSize={['xs', null, 'sm']}
            color={brandColors.charcoal}
          >
            {descriptionContent}
          </Text>
        </Flex>
      </Flex>

      <Text
        mt={title ? 2 : 0}
        display={title ? ['block', null, 'none'] : 'none'}
        fontSize={['xs', null, 'sm']}
        color={brandColors.charcoal}
      >
        {descriptionContent}
      </Text>
    </Box>
  );
};

export default QantasPointBanner;
